import cookie from 'react-cookies';
import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* login({ email, password }) {
  try {
    const result = yield call(API.login, email, password);

    if (result.key) {
      cookie.save('token', result.key, {
        path: '/',
      });
      yield put({
        type: actionTypes.AUTH_LOGIN_SUCCESS,
        result,
      });
    } else {
      yield put({
        type: actionTypes.AUTH_LOGIN_ERROR,
        error: result.error,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AUTH_LOGIN_ERROR,
      error,
    });
  }
}

export function* signup(data) {
  try {
    const result = yield call(API.signup, data);

    if (result.key) {
      yield put({
        type: actionTypes.AUTH_SIGNUP_SUCCESS,
        result,
      });
    } else {
      yield put({
        type: actionTypes.AUTH_SIGNUP_ERROR,
        error: result.error,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AUTH_SIGNUP_ERROR,
      error,
    });
  }
}

export function* forgot({ email }) {
  try {
    const result = yield call(API.forgot, email);

    if (result.detail) {
      yield put({
        type: actionTypes.AUTH_FORGOT_SUCCESS,
      });
    } else {
      yield put({
        type: actionTypes.AUTH_FORGOT_ERROR,
        error: result.error,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AUTH_FORGOT_ERROR,
      error,
    });
  }
}

export function* retrieveEmail({ uid, token }) {
  try {
    const result = yield call(API.retrieveEmail, uid, token);

    if (result.email) {
      yield put({
        type: actionTypes.AUTH_EMAIL_SUCCESS,
        email: result.email,
      });
    } else {
      yield put({
        type: actionTypes.AUTH_EMAIL_ERROR,
        error: result.error,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AUTH_EMAIL_ERROR,
      error,
    });
  }
}

export function* resetPassword({ token, uid, password }) {
  const data = {
    token,
    uid,
    new_password1: password,
    new_password2: password,
  };

  try {
    const result = yield call(API.resetPassword, data);
    if (result) {
      yield put({
        type: actionTypes.AUTH_RESET_SUCCESS,
      });
    } else {
      yield put({
        type: actionTypes.AUTH_RESET_ERROR,
        error: result.error,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AUTH_RESET_ERROR,
      error,
    });
  }
}

export function* getConfirmEmail({ token }) {
  try {
    const result = yield call(API.getConfirmEmail, token);

    if (result.email) {
      yield put({
        type: actionTypes.AUTH_CONFIRM_EMAIL_SUCCESS,
        email: result.email,
      });
    } else {
      yield put({
        type: actionTypes.AUTH_CONFIRM_EMAIL_ERROR,
        error: result.error,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AUTH_CONFIRM_EMAIL_ERROR,
      error,
    });
  }
}

export function* verifyEmailByToken({ token }) {
  try {
    const result = yield call(API.verifyEmailByToken, {
      key: token,
    });

    if (result.ok) {
      yield put({
        type: actionTypes.AUTH_VERIFY_EMAIL_SUCCESS,
        result,
      });
    } else {
      yield put({
        type: actionTypes.AUTH_VERIFY_EMAIL_ERROR,
        error: result.error,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AUTH_VERIFY_EMAIL_ERROR,
      error,
    });
  }
}

export function* resendConfirmationLink({ email }) {
  try {
    const result = yield call(API.resendConfirmationLink, {
      email: email,
    });

    if (result.ok) {
      yield put({
        type: actionTypes.RESEND_CONFIRMATION_LINK_SUCCESS,
        result,
      });
    } else {
      yield put({
        type: actionTypes.RESEND_CONFIRMATION_LINK_ERROR,
        error: result.error,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.RESEND_CONFIRMATION_LINK_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/auth.js